import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DocumentIcon from '~/assets/icons/document.svg?react';
import ImageIcon from '~/assets/icons/image.svg?react';
import VectorIcon from '~/assets/icons/vector.svg?react';
import DownloadQRModalContentLayout from '~/components/download/DownloadQRModalContentLayout';
import DownloadQRTypeButton from '~/components/download/DownloadQRTypeButton';
import { useDownloadQr, useDownloadQrs } from '~/queries/qrCodeTable';

type IdAndType = { id: number; type: string };
type DownloadContentProps = {
  imageName?: string;
  downloadIdsWithTypes: IdAndType | IdAndType[];
};
export default function DownloadContent({ imageName, downloadIdsWithTypes }: DownloadContentProps) {
  const { t } = useTranslation();
  const [checkedFormat, setCheckedFormat] = useState('');
  const { mutate: donwnloadQRs, status: statusQRs } = useDownloadQrs();
  const { mutate: donwnloadQR, status: statusQR } = useDownloadQr();

  const isLoading = statusQR === 'pending' || statusQRs === 'pending';

  const imageFormats = [
    { name: 'jpeg', icon: <ImageIcon />, text: t('downloadModal:jpeg') },
    { name: 'png', icon: <ImageIcon />, text: t('downloadModal:png') },
    { name: 'svg', icon: <VectorIcon />, text: t('downloadModal:svg') },
    { name: 'pdf', icon: <DocumentIcon />, text: t('downloadModal:pdf') },
  ] as const;

  return (
    <DownloadQRModalContentLayout isLoading={isLoading}>
      {imageFormats.map(({ name, icon, text }) => (
        <DownloadQRTypeButton
          key={name}
          type={name}
          icon={icon}
          text={text}
          onClick={() => {
            if (Array.isArray(downloadIdsWithTypes)) {
              const ids = downloadIdsWithTypes.map((item) => item.id);
              donwnloadQRs({ qr_ids: ids, image_format: name });
              downloadIdsWithTypes.forEach((item) => {
                window.dataLayer?.push({
                  event: 'download_qr_code',
                  qr_code_id: item.id,
                  qr_code_type: item.type,
                });
              });
              setCheckedFormat(name);
            } else {
              donwnloadQR({ id: String(downloadIdsWithTypes.id), format: name, name: imageName });
              window.dataLayer?.push({
                event: 'download_qr_code',
                qr_code_id: downloadIdsWithTypes.id,
                qr_code_type: downloadIdsWithTypes.type,
              });
              setCheckedFormat(name);
            }
          }}
          isLoading={isLoading && name === checkedFormat}
        />
      ))}
    </DownloadQRModalContentLayout>
  );
}
